import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { DateRangeTypeEnum, PageTypeEnum } from 'src/app/shared/models/filter.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ApprovalsListComponent } from "../components/approvals-list/approvals-list.component";
import { ApprovalStore } from '../store/approval-store';
import { EApprovalStatus, EnumApprovalsTabs } from 'src/app/models/approval.model';
import { GlobalStore } from 'src/app/store/global-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReportsListComponent } from 'src/app/features/reports/components/reports-list/reports-list.component';
import { ReportStore } from 'src/app/features/reports/store/report-store';

@Component({
    selector: 'que-approvals',
    imports: [CommonModule, TranslateDirective, TranslatePipe, ApprovalsListComponent, ReportsListComponent],
    templateUrl: './approvals.component.html',
    styleUrls: ['./approvals.component.scss'],
    providers: [ApprovalStore, ReportStore, ManipulationsToolbarStore]
})
export class ApprovalsComponent implements OnInit {
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  #globalStore = inject(GlobalStore);
  showTabApprovers = this.#globalStore.showTabApprovers;
  showTabRecords = this.#globalStore.showTabRecords;
  // DBJR-193: "Reports" is a tab within Approvals (after Download Records), not its own screen -
  // reuses the same grid/filter/toolbar shell that the other tabs share.
  reportsTab$ = toSignal(this.#manipulationsToolbarStore.reportsTab$);

  ngOnInit(): void {
    this.#manipulationsToolbarStore.updatePageType(PageTypeEnum.Approvals);
    if (this.showTabApprovers())
      this.#manipulationsToolbarStore.updateFilterDataSelected({ 'approvalsTabs': EnumApprovalsTabs.PendingApproval })
    else
      this.#manipulationsToolbarStore.updateFilterDataSelected({ 'approvalsTabs': EnumApprovalsTabs.DownloadRecords })
  }
}
